var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
      attrs: {
        title: !_vm.inputForm.id ? "新增" : "修改",
        "close-on-click-modal": false,
        "append-to-body": "",
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "inputForm",
          attrs: {
            size: "small",
            model: _vm.inputForm,
            rules: _vm.dataRule,
            "label-width": "80px",
          },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.doSubmit()
            },
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "标签中文", prop: "label" } },
            [
              _c("el-input", {
                attrs: { placeholder: "标签" },
                model: {
                  value: _vm.inputForm.label,
                  callback: function ($$v) {
                    _vm.$set(_vm.inputForm, "label", $$v)
                  },
                  expression: "inputForm.label",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "标签英文", prop: "labelEn" } },
            [
              _c("el-input", {
                attrs: { placeholder: "标签英文" },
                model: {
                  value: _vm.inputForm.labelEn,
                  callback: function ($$v) {
                    _vm.$set(_vm.inputForm, "labelEn", $$v)
                  },
                  expression: "inputForm.labelEn",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "键值", prop: "value" } },
            [
              _c("el-input", {
                attrs: { placeholder: "键值" },
                model: {
                  value: _vm.inputForm.value,
                  callback: function ($$v) {
                    _vm.$set(_vm.inputForm, "value", $$v)
                  },
                  expression: "inputForm.value",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "排序号", prop: "sort" } },
            [
              _c("el-input-number", {
                attrs: { step: 1, placeholder: "排序号" },
                model: {
                  value: _vm.inputForm.sort,
                  callback: function ($$v) {
                    _vm.$set(_vm.inputForm, "sort", $$v)
                  },
                  expression: "inputForm.sort",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", icon: "el-icon-circle-close" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("关闭")]
          ),
          _c(
            "el-button",
            {
              directives: [{ name: "noMoreClick", rawName: "v-noMoreClick" }],
              attrs: {
                size: "small",
                type: "primary",
                icon: "el-icon-circle-check",
              },
              on: {
                click: function ($event) {
                  return _vm.doSubmit()
                },
              },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }